import "../App.css";

import logo from "../assets/logo.png";
import SectionMessage from "@atlaskit/section-message";

const Header = () => {
  return (
    <div>
      <div className="header">
        <div className="logo-title" style={{ cursor: "pointer" }}>
          <img src={logo} className="logo-image" alt="logo" />
          <span className="app-name">Insight Assets Backup & Migration</span>
        </div>
      </div>
      <div style={{ marginTop: "10px" }}>
        <SectionMessage
          appearance="warning"
          title="Action required: Connect support ends April 15, 2026"
        >
          <p>
            This app is moving from the legacy Connect framework to Forge,
            Atlassian's current app platform. Starting April 15, 2026, the
            Connect version will stop working entirely — backups, migrations,
            and scheduled jobs will no longer run.
            <br />
            <br />
            <strong>What to do:</strong> Install the Forge version before the
            cutoff. Your existing schemas, backups, and migration history carry
            over automatically.
            <br />
            Go to <strong> Jira Settings → Apps → Manage Apps </strong>.
          </p>
        </SectionMessage>
      </div>
    </div>
  );
};

export default Header;
